import { getFeatureFlag } from '@fs/zion-flags'
import { videoDurationStringToMs, getNowTimestamp } from './dateTimeHelpers'

const LIVE_START_GRACE_PERIOD_MS = 100

export function getIsLive({ date: videoStartTimestamp, videoDuration, now = getNowTimestamp() }) {
  const forceLiveFlag = getFeatureFlag('rootstech_force_live')
  videoDuration = videoDurationStringToMs(videoDuration)
  const videoEndTimestamp = videoStartTimestamp + videoDuration
  const isLive = now >= videoStartTimestamp - LIVE_START_GRACE_PERIOD_MS && now <= videoEndTimestamp
  return forceLiveFlag.isOn || isLive
}

export function getIsPastBroadcast({ date: videoStartTimestamp, videoDuration, nowTimestamp = getNowTimestamp() }) {
  videoDuration = videoDurationStringToMs(videoDuration)

  const videoEndTimestamp = videoStartTimestamp + videoDuration
  const isPastBroadcast = nowTimestamp > videoEndTimestamp
  return isPastBroadcast
}
